/**
 * Vendor libraries first.
 *
 * To add an external library, check on https://www.npmjs.com for example 'isotope' which will instruct you import the library with `npm i isotope --save-dev`.
 *
 * Then to include the library 'require' the package with `require('isotope');`.
 */
import $ from "jquery";
import jQueryBridget from "jquery-bridget";
import Isotope from "isotope-layout";
import Swiper from "swiper";
import "lity";

const lity = require("lity");

// make Isotope a jQuery plugin
jQueryBridget("isotope", Isotope, $);

// Accordion

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

// Filter expand

var acc = document.getElementsByClassName("filter-expand");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

// Nav fixes

$(document).ready(function() {
  $(".nav-main__menu-sub__link").on("click", function(e) {
    e.preventDefault();
    window.location = e.target.href;
  });
  $(".nav-main__menu-sub").each(function() {
    if ($(this).children().length > 4) {
      $(this).addClass("two-rows");
    }
  });
});

// Make MISSION bold wherever it appears

var mission = "MISSION";

$(
  "p:contains(" +
    mission +
    "), span:contains(" +
    mission +
    "), li:contains(" +
    mission +
    "), a:contains(" +
    mission +
    "), h1:contains(" +
    mission +
    "), h2:contains(" +
    mission +
    ")",
  document.body
).each(function() {
  $(this).html(
    $(this)
      .html()
      .replace(new RegExp(mission, "g"), "<strong>" + mission + "</strong>")
  );
});

/**  Isotope filtering for Jobs */

var selectFilters = {};
var selectFilter;
var qsRegex;

// init Isotope
var $grid = $(".job-grid").isotope({
  itemSelector: ".item",
  filter: function() {
    var $this = $(this);
    var searchResult = qsRegex
      ? $this
          .find(".job-title")
          .text()
          .match(qsRegex)
      : true;
    var selectResult = selectFilter ? $this.is(selectFilter) : true;
    return searchResult && selectResult;
  },
});

// flatten object by concatting values
function concatValues(obj) {
  var value = "";
  for (var prop in obj) {
    value += obj[prop];
  }
  return value;
}

// store filter for each group
$(".filters select").on("change", function(event) {
  var $select = $(event.target);
  // get group key
  var filterGroup = $select.attr("value-group");
  // set filter for group
  selectFilters[filterGroup] = event.target.value;
  // combine filters
  selectFilter = concatValues(selectFilters);
});

// search term on button click
var $quicksearch = $("#search").on("click", function() {
  qsRegex = new RegExp($("#quicksearch").val(), "gi");
  $grid.isotope(qsRegex);
});

// search term when press Enter
$("#quicksearch").keyup(function(e) {
  if (e.key === 16 || e.key === 13 || e.key === "Enter") {
    qsRegex = new RegExp(document.getElementById("quicksearch").value, "gi");
    $grid.isotope(qsRegex);
  }
});

// display message box if no filtered items
$("#search").on("click", function() {
  if (!$(".job-grid").data("isotope").filteredItems.length > 0) {
    $("#msg-box").fadeIn("slow");
  } else {
    $("#msg-box").fadeOut("fast");
  }
});

$("#quicksearch").keyup(function(e) {
  if (e.key === 16 || e.key === 13 || e.key === "Enter") {
    if (!$(".job-grid").data("isotope").filteredItems.length > 0) {
      $("#msg-box").fadeIn("slow");
    } else {
      $("#msg-box").fadeOut("fast");
    }
  }
});

// reset filters
// $("#clear").on( 'click', function(event) {
//     event.preventDefault();
//     $("#quicksearch").val("");
//     $(".filters select").val("*");
//     $grid.isotope({
//         filter: ""
//     })
// });

/**  Isotope filtering for News */

var itemSelector = ".news-item";
var $checkboxes = $(".filter-item");
var $container = $(".news-grid").isotope({
  itemSelector: itemSelector,
  layoutMode: "masonry",
  masonry: {
    gutter: 100,
  },
});

//Ascending order
var responsiveIsotope = [
  [480, 4],
  [720, 6],
];
var itemsPerPageDefault = 8;
var itemsPerPage = defineItemsPerPage();
var currentNumberPages = 1;
var currentPage = 1;
var currentFilter = "*";
var filterAttribute = "data-filter";
var filterValue = "";
var pageAttribute = "data-page";
var pagerClass = "isotope-pager";
var wordPage = "";

// update items based on current filters
function changeFilter(selector) {
  $container.isotope({ filter: selector });
}

//grab all checked filters and goto page on fresh isotope output
function goToPage(n) {
  currentPage = n;
  var selector = itemSelector;
  var exclusives = [];
  // for each box checked, add its value and push to array
  $checkboxes.each(function(i, elem) {
    if (elem.checked) {
      selector += currentFilter != "*" ? "." + elem.value : "";
      exclusives.push(selector);
    }
  });
  // smash all values back together for 'and' filtering
  filterValue = exclusives.length ? exclusives.join("") : "*";

  // add page number to the string of filters
  var wordPage = currentPage.toString();
  filterValue += "." + wordPage;

  changeFilter(filterValue);
}

// determine page breaks based on window width and preset values
function defineItemsPerPage() {
  var pages = itemsPerPageDefault;

  for (var i = 0; i < responsiveIsotope.length; i++) {
    if ($(window).width() <= responsiveIsotope[i][0]) {
      pages = responsiveIsotope[i][1];
      break;
    }
  }
  return pages;
}

function setPagination() {
  var SettingsPagesOnItems = (function() {
    var itemsLength = $container.children(itemSelector).length;
    var pages = Math.ceil(itemsLength / itemsPerPage);
    var item = 1;
    var page = 1;
    var selector = itemSelector;
    var exclusives = [];
    // for each box checked, add its value and push to array
    $checkboxes.each(function(i, elem) {
      if (elem.checked) {
        selector += currentFilter != "*" ? "." + elem.value : "";
        exclusives.push(selector);
      }
    });
    // smash all values back together for 'and' filtering
    filterValue = exclusives.length ? exclusives.join("") : "*";
    // find each child element with current filter values
    $container.children(filterValue).each(function() {
      // increment page if a new one is needed
      if (item > itemsPerPage) {
        page++;
        item = 1;
      }
      // add page number to element as a class
      wordPage = page.toString();

      var classes = $(this)
        .attr("class")
        .split(" ");
      var lastClass = classes[classes.length - 1];
      // last class shorter than 4 will be a page number, if so, grab and replace
      if (lastClass.length < 4) {
        $(this).removeClass();
        classes.pop();
        classes.push(wordPage);
        classes = classes.join(" ");
        $(this).addClass(classes);
      } else {
        // if there was no page number, add it
        $(this).addClass(wordPage);
      }
      item++;
    });
    currentNumberPages = page;
  })();

  // create page number navigation
  var CreatePagers = (function() {
    var $isotopePager =
      $("." + pagerClass).length == 0
        ? $('<div class="' + pagerClass + '"></div>')
        : $("." + pagerClass);

    $isotopePager.html("");
    if (currentNumberPages > 1) {
      for (var i = 0; i < currentNumberPages; i++) {
        var $pager = $(
          '<a href="javascript:void(0);" class="pager" ' +
            pageAttribute +
            '="' +
            (i + 1) +
            '"></a>'
        );
        $pager.html(i + 1);

        $pager.click(function() {
          var page = $(this)
            .eq(0)
            .attr(pageAttribute);
          $(".pager").removeClass("active");
          $(this).addClass("active");
          goToPage(page);
        });
        $pager.appendTo($isotopePager);
      }
    }
    $container.after($isotopePager);
    $('[data-page="1"]').addClass("active");
  })();
}
// remove checks from all boxes and refilter
function clearAll() {
  $checkboxes.each(function(i, elem) {
    if (elem.checked) {
      elem.checked = null;
    }
  });
  currentFilter = "*";
  setPagination();
  goToPage(1);
}

setPagination();
goToPage(1);

//event handlers
$checkboxes.change(function() {
  var filter = $(this).attr(filterAttribute);
  currentFilter = filter;
  setPagination();
  goToPage(1);
});

$("#clear-filters").click(function() {
  clearAll();
});

$(window).resize(function() {
  itemsPerPage = defineItemsPerPage();
  setPagination();
  goToPage(1);
});

// Job application form show on click

$(document).ready(function() {
  $("#showapp").click(function() {
    document.getElementById("application-form").style.display = "block";
  });
});

$(".board-grid").isotope({
  itemSelector: ".board-item",
  layoutMode: "masonry",
  masonry: {
    gutter: 100,
  },
});

$(".scroll-icon").on("click", function(e) {
  $("html, body").animate(
    {
      scrollTop: $(this)
        .closest("#hero-video")
        .next()
        .offset().top,
    },
    150
  );
});

/**
 * Initializes the Swiper carousel on smaller screens, manages
 * the changing of styles on hover, and handles the show and hide
 * functionality upon clicking the roundel or 'go back' links.
 */
const initializeRoundels = () => {
  let currentSwiper = null;
  const roundels = document.querySelectorAll(".circle");
  const roundelLists = document.querySelectorAll(".roundel-list-wrapper");
  const goBackLinks = document.querySelectorAll(".go-back");
  const openingStatement = document.getElementById("opening-statement");
  const ourMissionHeading = document.getElementById("our-mission-heading");

  const initializeSwiper = (list) => {
    if (!currentSwiper && window.innerWidth < 768) {
      currentSwiper = new Swiper(list.querySelector(".swiper-container"), {
        slidesPerView: 1,
        spaceBetween: 30,
      });
    }
  };

  const handleRoundelMouseEnter = (roundel) => {
    const color = roundel.getAttribute("data-color");
    roundel.style.backgroundColor = color;
    roundel.style.color = "white";
    roundel.querySelector(".circle-text").style.visibility = "hidden";
    roundel.querySelector(".circle-cross").style.display = "block";
  };

  const handleRoundelMouseLeave = (roundel) => {
    roundel.style.backgroundColor = "";
    roundel.style.color = "";
    roundel.querySelector(".circle-text").style.visibility = "";
    roundel.querySelector(".circle-cross").style.display = "none";
  };

  const handleRoundelClick = (roundel) => {
    const index = roundel.getAttribute("data-index");
    openingStatement.style.display = "none";
    ourMissionHeading.style.display = "none";
    document.getElementById("roundels").style.display = "none";

    const borderColor = window.getComputedStyle(roundel).borderColor;

    roundelLists.forEach((list) => {
      if (list.getAttribute("data-index") === index) {
        list.style.display = "block";
        const swiperSlides = list.querySelectorAll(".swiper-slide");
        swiperSlides.forEach((slide) => {
          const listItem = slide.querySelector("li");
          listItem.style.setProperty("--bullet-border-color", borderColor);
        });
        initializeSwiper(list);
      }
    });
  };

  const handleGoBackClick = () => {
    openingStatement.style.display = "block";
    ourMissionHeading.style.display = "block";
    document.getElementById("roundels").style.display = "flex";
    roundelLists.forEach((list) => (list.style.display = "none"));

    if (currentSwiper) {
      currentSwiper.destroy(true, true);
      currentSwiper = null;
    }
  };

  // Add event listeners to roundels
  roundels.forEach((roundel) => {
    roundel.addEventListener("mouseenter", () =>
      handleRoundelMouseEnter(roundel)
    );
    roundel.addEventListener("mouseleave", () =>
      handleRoundelMouseLeave(roundel)
    );
    roundel.addEventListener("click", () => handleRoundelClick(roundel));
  });

  // Add event listeners to 'go back' links
  goBackLinks.forEach((link) => {
    link.addEventListener("click", handleGoBackClick);
  });

  // Handle window resize to reinitialize or destroy Swiper
  window.addEventListener("resize", () => {
    if (currentSwiper && window.innerWidth >= 768) {
      currentSwiper.destroy(true, true);
      currentSwiper = null;
    } else if (!currentSwiper && window.innerWidth < 768) {
      roundelLists.forEach((list) => {
        if (list.style.display === "block") {
          initializeSwiper(list);
        }
      });
    }
  });
};

// Attach the function to the DOMContentLoaded event
document.addEventListener("DOMContentLoaded", initializeRoundels);

// Display either white or blue logo

document.addEventListener("DOMContentLoaded", function() {
  let container = document.querySelector(".hero-banner");
  let logoBlue = document.querySelector(".logo-blue");
  let logoWhite = document.querySelector(".logo-white");
  let navToggleButton = document.querySelector(".hamburger-menu");
  let htmlElement = document.documentElement;

  if (container && container.classList.contains("fifty-fifty")) {
    logoBlue.style.display = "none";
    logoWhite.style.display = "block";
  }

  if (navToggleButton) {
    navToggleButton.addEventListener("click", function() {
      setTimeout(function() {
        if (htmlElement.classList.contains("open-menu")) {
          console.log("menu oepn");
          // If nav menu is open, show blue logo
          logoBlue.style.display = "block";
          logoWhite.style.display = "none";
        } else {
          // If nav menu is closed, revert to initial state
          if (
            (container && container.classList.contains("fifty-fifty")) ||
            document.body.classList.contains("home")
          ) {
            console.log("menu closed block present or home page");
            logoBlue.style.display = "none";
            logoWhite.style.display = "block";
          } else {
            console.log("menu closed");
            logoWhite.style.display = "none";
            logoBlue.style.display = "block";
          }
        }
      }, 150);
    });
  }
});

// Roundels layout
document.addEventListener("DOMContentLoaded", function() {
  var circles = document.querySelectorAll(".circle");
  if (circles.length % 2 !== 0) {
    circles[0].classList.add("circle-first-row");
  }
});

$(document).ready(function() {
  // Popup message
  if ($("#popup").length) {
    setTimeout(function() {
      lity.options(
        "template",
        '<div class="lity" role="dialog" aria-label="Dialog Window (Press escape to close)" tabindex="-1"><div class="lity-wrap" role="document"><div class="lity-loader" aria-hidden="true">Loading...</div><div class="lity-container"><div class="lity-content"></div></div></div></div>'
      );
      var lightbox = lity("#popup");
    });
  }
});

 $(window).on("load", function () {
      $(".nav-main .sub-menu").on("click", function () {
        return !$(this).hasClass("activated") && !$(this).parent("ul").hasClass("sub-run") && ($(this).addClass("activated"),
          $(this).parent("ul").addClass("sub-run"),
          void $(".header-social").addClass("activated"))
      }),
        $("#go-back").on("click", function () {
          $(".nav-main .sub-menu").removeClass("activated"),
            $(".nav-main .sub-menu").parent("ul").removeClass("sub-run"),
            $(".header-social").removeClass("activated")
        })
    })